var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Checkbox, Dialog, FormControlLabel, FormGroup, Grid, TextField, } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { excluiAnistia, } from "../../apis/api";
import { formatCurrency } from "../../util/utilitarios";
import { toast } from "react-toastify";
import Loader from "../Loading";
import { useHistory } from "react-router-dom";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    });
});
function BootstrapDialogTitle(props) {
    var children = props.children, onClose = props.onClose, other = __rest(props, ["children", "onClose"]);
    return (_jsxs(DialogTitle, __assign({ sx: { m: 0, p: 1, backgroundColor: "#034EA2", color: "white" } }, other, { children: [children, onClose ? (_jsx(IconButton, __assign({ "aria-label": "close", onClick: onClose, sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "white",
                } }, { children: _jsx(CloseIcon, {}) }))) : null] })));
}
export function DialoCancelarAnistia(props) {
    var handleClose = props.handleClose;
    var dataUser = props.dataUser;
    var dadosAnistia = props.dadosAnistia;
    var _a = React.useState(true), open = _a[0], setOpen = _a[1];
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState({
        ANISTIA_INDEVIDA: false,
        OUTROS: false,
        POR_VALORES_INCORRETOS: false,
    }), checkedItems = _c[0], setCheckedItems = _c[1];
    var _d = React.useState(""), reason = _d[0], setReason = _d[1];
    var history = useHistory();
    var handleChange = function (event) {
        var _a = event.target, name = _a.name, checked = _a.checked;
        setCheckedItems(__assign(__assign({}, checkedItems), { ANISTIA_INDEVIDA: name === "ANISTIA_INDEVIDA" ? checked : false, OUTROS: name === "OUTROS" ? checked : false, POR_VALORES_INCORRETOS: name === "POR_VALORES_INCORRETOS" ? checked : false }));
    };
    function handleCancelarAnistia() {
        return __awaiter(this, void 0, void 0, function () {
            var checkedItemsTrue, cancelamento;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(checkedItems.ANISTIA_INDEVIDA ||
                            checkedItems.OUTROS ||
                            checkedItems.POR_VALORES_INCORRETOS)) {
                            toast.warn("Marque algum motivo para a exclusão");
                            return [2 /*return*/];
                        }
                        checkedItemsTrue = Object.entries(checkedItems)
                            .filter(function (_a) {
                            var key = _a[0], value = _a[1];
                            return value === true;
                        })
                            .map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return key;
                        });
                        setLoading(true);
                        return [4 /*yield*/, excluiAnistia((dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.numeroAnistia) || 0, reason, checkedItemsTrue[0])];
                    case 1:
                        cancelamento = _a.sent();
                        if (!(cancelamento.data.status === "FALHA")) {
                            toast.success("Anistia cancelada com sucesso");
                            setLoading(false);
                            handleClose();
                        }
                        else {
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        setLoading(false);
                        setTimeout(function () {
                            console.log("Após 5 segundos");
                            handleDialogClose();
                            history.push({
                                pathname: "/dar-ipva",
                            });
                        }, 5000);
                        return [2 /*return*/];
                }
            });
        });
    }
    var handleDialogClose = function () {
        setOpen(false);
        handleClose();
    };
    var formatDate = function (timestamp) {
        var date = new Date(timestamp);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        // Formatando a data no formato "dd/MM/aaaa"
        var formattedDate = "".concat(day.toString().padStart(2, "0"), "/").concat(month
            .toString()
            .padStart(2, "0"), "/").concat(year);
        return formattedDate;
    };
    var handleReasonChange = function (event) {
        setReason(event.target.value);
    };
    return (_jsx(_Fragment, { children: _jsxs(BootstrapDialog, __assign({ onClose: handleDialogClose, "aria-labelledby": "customized-dialog-title", open: open, sx: {} }, { children: [_jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), _jsx(BootstrapDialogTitle, __assign({ id: "customized-dialog-title", onClose: handleClose }, { children: "Cancelar Anistia" })), _jsxs(DialogContent, __assign({ dividers: true }, { children: [_jsx(Typography, { gutterBottom: true }), _jsx("div", { style: {
                                marginTop: 20,
                                marginBottom: 20,
                                fontWeight: "bold",
                            } }), _jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Numero Anistia:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.numeroAnistia }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Data Anistia:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatDate((dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.dataAnistia) || 0) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "N\u00FAmero de parcelas:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.numeroParcelas }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Valor divida:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.valorDivida) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Renavam:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: dadosAnistia === null || dadosAnistia === void 0 ? void 0 : dadosAnistia.data.renavam }) }))] }))] }), _jsxs("div", { children: [_jsx(Typography, { children: "Qual o motivo da exclus\u00E3o?" }), _jsxs(FormGroup, { children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: checkedItems.ANISTIA_INDEVIDA, onChange: handleChange, name: "ANISTIA_INDEVIDA" }), label: "ANISTIA INDEVIDA" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: checkedItems.OUTROS, onChange: handleChange, name: "OUTROS" }), label: "OUTROS" }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: checkedItems.POR_VALORES_INCORRETOS, onChange: handleChange, name: "POR_VALORES_INCORRETOS" }), label: "POR VALORES INCORRETOS" })] })] }), _jsx(Grid, { children: _jsx(Grid, __assign({ item: true }, { children: _jsx(TextField, { label: "Motivo da exclus\u00E3o", value: reason, onChange: handleReasonChange, inputProps: { maxLength: 250 }, multiline: true, rows: 2, fullWidth: true }) })) }), _jsxs("div", __assign({ style: grupoButtoes }, { children: [_jsx(Button, __assign({ sx: {
                                                backgroundColor: "#034EA2",
                                                color: "white",
                                            }, onClick: function () { return handleCancelarAnistia(); } }, { children: "Cancelar Anistia" })), _jsx(Button, __assign({ sx: {
                                                backgroundColor: "#E4E4E4",
                                                color: "black",
                                            }, onClick: function () { return handleDialogClose(); } }, { children: "Cancelar" }))] }))] })] }))] })) }));
}
var itemInfo = {
    marginLeft: 10,
};
var item = {
    marginBottom: 5,
    fontSize: 18,
    display: "flex",
};
var grupoButtoes = {
    marginTop: 15,
    display: "flex",
    justifyContent: "space-between",
};
